// extracted by mini-css-extract-plugin
export default {"container":"UpcomingEvents_container__PNrnG","when":"UpcomingEvents_when__r52iu"};